import { BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import CalendarViewWeek from "@mui/icons-material/CalendarViewWeek";
import FolderOutlined from "@mui/icons-material/FolderOutlined";
import Search from "@mui/icons-material/Search";
import Today from "@mui/icons-material/Today";
import { Link, useLocation } from "react-router-dom";
import { pagePath } from "../pages/task/taskUrl";
import { useWorkspace } from "./Workspace";

// tabBarHeight is the height of the bar without the safe-area inset under it, in px
export const tabBarHeight = 56;

// tabBarOffset is how far something pinned to the bottom of the screen sits up to
// clear the bar
export const tabBarOffset = `calc(${tabBarHeight}px + env(safe-area-inset-bottom))`;

type Tab = "today" | "week" | "projects" | "search";

// MobileTabBar is a phone's way between the main pages. The pages it doesn't name are
// in the menu (see NavList).
export function MobileTabBar(props: {
    searching: boolean;
    onSearch: () => void;
    onNavigate: () => void;
}) {
    const loc = useLocation();
    const ws = useWorkspace();

    const page = pagePath(loc.pathname);

    let value: Tab | null = null;
    if (props.searching) value = "search";
    else if (page.endsWith("/tasks/day")) value = "today";
    else if (page.endsWith("/tasks/calendar")) value = "week";
    else if (loc.pathname.includes("/projects")) value = "projects";

    return (
        <Paper square elevation={0} sx={{
            flexShrink: 0,
            borderTop: 1,
            borderColor: "divider",
            pb: "env(safe-area-inset-bottom)",
        }}>
            <BottomNavigation showLabels value={value} sx={{ height: tabBarHeight }}>
                <BottomNavigationAction value="today" label="Today" icon={<Today />}
                                        component={Link} to={ws.path("/tasks/day")} onClick={props.onNavigate} />
                <BottomNavigationAction value="week" label="Week" icon={<CalendarViewWeek />}
                                        component={Link} to={ws.path("/tasks/calendar") + "?mode=week"}
                                        onClick={props.onNavigate} />
                <BottomNavigationAction value="projects" label="Projects" icon={<FolderOutlined />}
                                        component={Link} to={ws.path("/projects")} onClick={props.onNavigate} />
                <BottomNavigationAction value="search" label="Search" icon={<Search />} onClick={props.onSearch} />
            </BottomNavigation>
        </Paper>
    );
}
